import type { RequestScope } from "@/types/request-scope";
import type { TelemetryPage } from "./page-catalog";
import type { TelemetryCollector } from "./collector";
export {
  TelemetryCollector,
  SESSION_IDLE_MS,
  type UsageSession,
} from "./collector";
export { resolveTelemetryPage, type TelemetryPage } from "./page-catalog";

let activeCollector: TelemetryCollector | null = null;
/** App composition owns installation; business features have no knowledge of HTTP or authentication credentials. */
export function installTelemetryCollector(collector: TelemetryCollector) {
  activeCollector = collector;
  return () => {
    if (activeCollector === collector) activeCollector = null;
    collector.dispose();
  };
}
/** An explicitly named action carries no free-form properties; disabled or unavailable collection is harmless. */
export function trackTelemetryAction(
  scope: RequestScope | null,
  action:
    | "message.preview_completed"
    | "message.submitted"
    | "poll.created"
    | "poll.updated"
    | "poll.closed"
    | "poll.invitation_submitted"
    | "person.saved"
    | "class.join_granted"
    | "recording.download_initiated"
    | "help.feature_opened",
  page?: TelemetryPage,
) {
  try {
    activeCollector?.action(scope, action, page);
  } catch {
    /* Business actions always retain their original outcome. */
  }
}
/** Router composition provides sanitized codes only after authentication and route resolution. */
export function visitTelemetryPage(page: TelemetryPage | null) {
  try {
    activeCollector?.visit(page);
  } catch {
    /* Restricted browser capabilities must not break rendering. */
  }
}
